const wowApp = require('angular').module('oly.common');

wowApp.directive('olyGrabFocus', ['$timeout', require('./grabfocus.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/grabfocus/index.js